import { Button, Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { CreateActivityModal } from 'components';
import useRouter from 'utils/useRouter';

const useStyles = makeStyles(theme => ({
  root: {},
  mainActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  deleteButton: {
    marginTop: theme.spacing(1),
    color: theme.palette.white,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  },
  closeButton: {
    marginTop: theme.spacing(1),
  },
  createButton: {
    // marginBottom: theme.spacing(1),
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  }
}));
const OtherActions = props => {
  const { className, handleClose, handleDelete, ...rest } = props;
  const [showConfirm, setShowConfirm] = useState(null);
  const classes = useStyles();
  const model = useSelector(state => state.models.slot);
  const [openActivity, setOpenActivity] = useState(false);
  const router = useRouter();

  const handleDeleteConfirm = (show) => {
    if (showConfirm) return showConfirm === "close" ? handleClose() : handleDelete();
    setShowConfirm(!showConfirm ? show : null);
  }

  const handleActivityOpen = () => {
    setOpenActivity(true);
  }

  const handleActivityClose = () => {
    setOpenActivity(false);
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Other actions" />
      <Divider />
      <CardContent>
        <Button className={classes.createButton} fullWidth onClick={handleActivityOpen}>
          Create Activity
        </Button>
        {showConfirm &&
          <Fragment>
            <Button fullWidth className={classes.closeButton} onClick={() => setShowConfirm(null)}>
              <CloseIcon className={classes.buttonIcon} />
              Cancel
            </Button>
            <Button fullWidth className={classes.deleteButton} onClick={() => handleDeleteConfirm(null)}>
              <DeleteIcon className={classes.buttonIcon} />
              {showConfirm === "delete" ? "Delete" : "Close"}
            </Button>
          </Fragment>
        }
        {!showConfirm &&
          <Fragment>
            <Button disabled={model.status === "closed"} fullWidth className={classes.deleteButton} onClick={() => handleDeleteConfirm("close")}>
              Close Slot
        </Button>
            <Button fullWidth className={classes.deleteButton} onClick={() => handleDeleteConfirm("delete")}>
              Delete Slot
        </Button>
          </Fragment>
        }
      </CardContent>
      <CreateActivityModal onClose={handleActivityClose} onCreate={id => router.history.push(`/activities/${id}/summary`)} open={openActivity} slot_id={model.id} />
    </Card>
  );
};

OtherActions.propTypes = {
  className: PropTypes.string
};

export default OtherActions;
